import Checkout from './CheckoutContainer';

export default Checkout;
